module.exports = __webpack_public_path__ + "static/media/high-fid-1.d68c683f.svg";